import { promotionsData } from "../../data/PromotionData"
import { useLeaderboard } from "../../data/LeaderboardProviderJiliGrandSlot"

export default function ModuleJiliGrandSlot({ closeModal }) {
  const promoData = promotionsData.find(
    (promo) => promo.title === "Jili Grand Slot"
  )

  const {
    leaderboardData,
    getBonusByRank,
    playerPosition,
    loadingBoard,
    getEventLabel,
    boardMode,
  } = useLeaderboard()

  return (
    <div className="promotion-module-pop-container">
      <div className="promotion-module-container">
        <button onClick={closeModal} className="promotion-close-btn">
          Close
        </button>

        <div className="promotion-module-main">
          <div className="promotion-leaderboard">
            <div className="promotion-module-banner">
              <img src={promoData.imgSrc} alt="Promotion Banner" />
              <div className="img-overlay"></div>
            </div>

            <div
              style={{
                textAlign: "center",
                margin: "10px 0",
                fontWeight: "bold",
                fontSize: "14px",
                color: "black",
              }}
            >
              {getEventLabel()}
            </div>

            <table className="promotion-module-table" style={{ marginTop: 5 }}>
              <thead>
                <tr>
                  <th>Ranking</th>
                  <th>Username</th>
                  <th>
                    {boardMode === "grandTurnover"
                      ? "Free Credits"
                      : "Free Spins"}
                  </th>
                </tr>
              </thead>
              <tbody>
                {loadingBoard ? (
                  <tr>
                    <td colSpan="3" style={{ textAlign: "center" }}>
                      Loading...
                    </td>
                  </tr>
                ) : leaderboardData.length > 0 ? (
                  leaderboardData.map((row, index) => {
                    const bonusValue = getBonusByRank(row.ranking)
                    const bonusDisplay = bonusValue
                      ? bonusValue.toLocaleString()
                      : "-"

                    return (
                      <tr key={index}>
                        <td>{row.ranking}</td>
                        <td>{row.masked}</td>
                        <td>{bonusDisplay}</td>
                      </tr>
                    )
                  })
                ) : (
                  <tr>
                    <td colSpan="3" style={{ textAlign: "center" }}>
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="promotion-module-cta">
            <span style={{ fontSize: 13, paddingInline: 10 }}>
              {loadingBoard ? (
                <p>Loading Leaderboard...</p>
              ) : playerPosition ? (
                <p>Jili Grand Slot: Rank#{playerPosition}</p>
              ) : (
                <p>
                  Leaderboard Winners will be announced every Monday at 12PM
                </p>
              )}
            </span>

            <a href="/slots/?provider=JILI">
              <button className="promotion-module-leaderboard-btn">
                Play Now
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
